var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dataLayerPush, normalizeObject } from "./utils";
var gfDataToDataLayer = function (e, specificEventData) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var form_id = eventData.form_id, form_title = eventData.form_title;
    var dlData = normalizeObject(__assign(__assign(__assign({}, eventData), { event: "form_interactions", event_category: "forms", event_label: "".concat(form_id, ":").concat(form_title) }), specificEventData));
    dataLayerPush(dlData);
};
var gravityFormInView = function (e) {
    gfDataToDataLayer(e, {
        event_action: "form_view",
        non_interaction: true,
        standard_interactions: 1,
        std_form_view: 1
    });
};
var gravityFormOnSubmit = function (e) {
    gfDataToDataLayer(e, {
        event_action: "form_submit_success",
        non_interaction: false,
        hi_form_submissions: 1,
        high_intent_interactions: 1
    });
};
var gravityFormOnStart = function (e) {
    gfDataToDataLayer(e, {
        event_action: "form_start",
        non_interaction: false
    });
};
var gravityFormOnError = function (e) {
    gfDataToDataLayer(e, {
        event_action: "form_error_view",
        event_errors: 1,
        total_errors: 1,
        error_type: "validation",
        non_interaction: false
    });
};
var gravityFormsNewsletter = function (e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var dlData = normalizeObject(eventData);
    dataLayerPush(dlData);
};
export { gravityFormInView, gravityFormOnSubmit, gravityFormOnStart, gravityFormOnError, gravityFormsNewsletter };
